export default [{"url":"https://hayzedd-test2-0.api.invexerp.io","name":"Branch 1","port":"5027","isStore":true,"isHQ":true}]